<template>
  <a-drawer :wrapClassName="$store.state.bgLight ? 'lightColor' : ''" :title="title" :width="1200" placement="right"
    :closable="true" @close="close" :visible="visible">
    <a-tabs v-model="tabsKey" v-if="visible">
      <a-tab-pane key="1" tab="基本信息">
        <a-spin :spinning="confirmLoading">
          <a-form :form="form">
            <a-row :gutter="24">
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="站点名称">
                  <span>{{ siteName }}</span>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="站点类型">
                  <span>{{ siteTypeName }}</span>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运维人员">
                  <a-tree-select style="width: 100%" :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                    :treeData="userTree" :disabled="disableSubmit" show-search treeNodeFilterProp="title"
                    v-decorator="['userId', validatorRules.userId]" placeholder="请选择运维人员">
                    <template slot="title" slot-scope="{ title }">ABC{{ title }}</template>
                  </a-tree-select>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本次核查时间">
                  <a-date-picker ref="replaceDate" format="YYYY-MM-DD HH:mm:ss" style="width: 100%"
                    v-decorator="['verificationDate', validatorRules.verificationDate]"
                    :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" :disabled="disableSubmit" />
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上次核查时间">
                  <a-date-picker ref="replaceDate" format="YYYY-MM-DD HH:mm:ss" style="width: 100%"
                    v-decorator="['lastTime', validatorRules.lastTime]"
                    :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" :disabled="disableSubmit" />
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护类型">
                  <j-dict-select-tag :triggerChange="true" :defaultState="true" dictCode="valid_category"
                    v-decorator="['category', validatorRules.category]" placeholder="请选择维护类型" :disabled="disableSubmit">
                  </j-dict-select-tag>
                </a-form-item>
              </a-col>
              <a-col :md="24" :sm="24">
                <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="备注">
                  <a-textarea :rows="2" placeholder="请输入备注" v-decorator="['remark', {}]" :disabled="disableSubmit" />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row style="margin-top: 10px">
              <a-col>
                <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 24 }" label="">
                  <iws-upload v-decorator="['fileList', validatorRules.fileList]" ref="iwupload"
                    :options="{ btnText: '上传' }" :disableSubmit="disableSubmit" filesrc="om_reagent_verification"
                    :srcid="this.model.id" @uploadFileList="handleUploadFileList">
                  </iws-upload>
                </a-form-item>

              </a-col>
            </a-row>

            <div class="drawer-msg" v-show="disableSubmit">
              <a-row>
                <a-col :span="12"> 创建信息：{{ model.createBy_userName }} （{{ model.createTime }}） </a-col>
                <a-col :span="12" v-if="model.updateBy_userName">
                  最后修改信息：{{ model.updateBy_userName }} （{{ model.updateTime }}）
                </a-col>
              </a-row>
            </div>
          </a-form>
          <div class="drawer-tool" v-if="(st === '21' || st === '31')">
            <a-button v-show='!disableSubmit' type="primary" :disabled="!networkStatus" icon="check"
              @click="tabsKey = '2'">开始核查</a-button>
          </div>
          <div v-else>
            <div class="drawer-tool" v-show="!disableSubmit">
              <a-button icon="close" @click="handleCancel">取消</a-button>
              <a-button type="primary" :disabled="!networkStatus" icon="check" @click="handleOk">确定</a-button>
            </div>
          </div>
        </a-spin>
      </a-tab-pane>

      <a-tab-pane key="2" tab="核查内容">
        <a-spin :spinning="confirmLoading">
          <a-row>
            <a-col :span="24" :gutter="24">
              <a-row v-if="!disableSubmit">
                <a-col :span="6" :gutter="2">
                  <a-button style="margin-bottom: 10px" @click="addTable" type="primary" icon="plus">新增</a-button>
                  <!--                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(dataItem[tablePageIndex - 1].id)">-->
                  <!--                    <a-button style="margin-bottom: 10px; margin-left: 10px" type="danger" icon="delete">删除</a-button>-->
                  <!--                  </a-popconfirm>-->
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24" :gutter="24">
                  <a-table :columns="columns" :dataSource="dataItem" bordered :pagination="false">
                    <template slot="factorId" slot-scope="text, record, index">
                      <!--                      @change="handleChangeFactorTable($event, record, 'factorId')"-->
                      <div style="display: flex; align-items: center">
                        <a-select showSearch :allowClear='false' placeholder='请选择监测因子' optionFilterProp='children'
                          v-model='record.factorId' style='width: 100%' :filterOption='filterOption'
                          :disabled='disableSubmit' @change="changeFactor(record)">
                          <a-select-option v-for='(item, key) in factorOptions' :key='key' :value='item.id'>{{
                            item.title }}({{ item.code }})
                          </a-select-option>
                        </a-select>
                      </div>
                    </template>
                    <template slot="concentration" slot-scope="text, record, index">
                      <div style="display: flex; align-items: center">
                        <a-input-number style="width: 100%" :step="0.001" v-model="record.concentration"
                          :disabled="disableSubmit" @change="handleAbsoluteError(record)" />
                          <span>{{ handleLabelTxt(record) }}</span>
                      </div>
                    </template>
                    <template slot="measuredValue" slot-scope="text, record, index">
                      <div style="display: flex; align-items: center">
                        <a-input-number style="width: 100%" :step="0.001" v-model="record.measuredValue"
                          :disabled="disableSubmit" @change="handleAbsoluteError(record)" />
                          <span>{{ handleLabelTxt(record) }}</span>
                      </div>
                    </template>

                    <template slot="afterTheLastCalibration" slot-scope="text, record, index">
                      <div style="display: flex; align-items: center">
                        <a-input-number style="width: 100%" :step="0.001" v-model="record.afterTheLastCalibration"
                          :disabled="disableSubmit" @change="handleRelativeError(record)"/>
                          <span>{{ handleLabelTxt(record) }}</span>
                      </div>
                    </template>
                    <template slot="beforeThisCalibration" slot-scope="text, record, index">
                      <div style="display: flex; align-items: center">
                        <a-input-number style="width: 100%" :step="0.001" v-model="record.beforeThisCalibration"
                          :disabled="disableSubmit"  @change="handleRelativeError(record)"/>
                          <span>{{ handleLabelTxt(record) }}</span>
                      </div>
                    </template>
                    <template slot="instrumentRange" slot-scope="text, record, index">
                      <div style="display: flex; align-items: center">
                        <a-input-number style="width: 100%" :step="0.001" v-model="record.instrumentRange"
                          :disabled="disableSubmit"  @change="handleRelativeError(record)"/>
                      </div>
                    </template>
                    <template slot="absoluteError" slot-scope="text, record, index">
                      <div style="display: flex; align-items: center">
                        <a-input-number style="width: 100%" v-model="record.absoluteError"
                          disabled />
                          <span>{{ handleLabelTxt(record) }}</span>
                      </div>
                    </template>
                    <template slot="relativeError" slot-scope="text, record, index">
                      <div style="display: flex; align-items: center">
                        <a-input-number style="width: 100%" v-model="record.relativeError"
                          disabled />
                      </div>
                    </template>
                    <template slot="qualified" slot-scope="text, record, index">
                      <div style="display: flex; align-items: center">
                        <j-dict-select-tag :triggerChange="true" :defaultState="true" dictCode="yes_no_status"
                          v-model="record.qualified" @change="getQualified(record, $event)" placeholder="请选择是否达标"
                          :disabled="disableSubmit" style="width: 100%">
                        </j-dict-select-tag>
                      </div>
                    </template>
                    <template slot="remark" slot-scope="text, record, index">
                      <div style="display: flex; align-items: center">
                        <a-textarea :autoSize="{ minRows: 5, maxRows: 5 }" placeholder="请输入备注..."
                          v-model="record.remark" :disabled="disableSubmit" />
                      </div>
                    </template>
                    <template slot="action" slot-scope="text, record, index">
                      <div style="max-width: 100px">
                        <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(index)">
                          <a-button size='small' type="danger" icon="delete">删除</a-button>
                        </a-popconfirm>
                      </div>
                    </template>
                  </a-table>
                  <!--                  <div style="height: 70vh; overflow: scroll">-->
                  <!--                    <div v-if="dataItem.length > 0" v-for="(item, index1) in dataItem"-->
                  <!--                      v-show="index1 + 1 == tablePageIndex">-->
                  <!--                      &lt;!&ndash;                    <span&ndash;&gt;-->
                  <!--                      &lt;!&ndash;                      style="font-size: 20px;margin: 10px 0;display: flex;justify-content: center;">第{{ index1 + 1&ndash;&gt;-->
                  <!--                      &lt;!&ndash;                      }}项</span>&ndash;&gt;-->
                  <!--                      <a-table style="width: 80%; margin: 20px 10%" :columns="columns" :dataSource="item" bordered-->
                  <!--                        :pagination="false" :scroll="{ y: 550 }">-->
                  <!--                        <template slot="value" slot-scope="text, record, index">-->

                  <!--                          <template v-if="record.code == 'equipmentId'">-->
                  <!--                            <div style="display: flex; align-items: center">-->
                  <!--                              <a-select style="width: 100%" placeholder="请选择仪表名称" :filterOption="filterOption" showSearch-->
                  <!--                                v-model="record.value" :disabled="disableSubmit" :allowClear="false"-->
                  <!--                                @dropdownVisibleChange="selectAssets(record, index, index1)">-->
                  <!--                              </a-select>-->
                  <!--                            </div>-->
                  <!--                          </template>-->

                  <!--                          <template v-if="record.code == 'productId'">-->
                  <!--                            <a-select style="width: 100%" placeholder="请选择标物名称" :filterOption="filterOption" showSearch-->
                  <!--                              v-model="record.value" :disabled="disableSubmit" :open="false"-->
                  <!--                              @dropdownVisibleChange="selectAssetChemical(record, index, index1)">-->
                  <!--                            </a-select>-->
                  <!--                          </template>-->

                  <!--                          <template v-if="record.code == 'usageAmount'">-->
                  <!--                            <a-input-number style="width: 50%" :step="0.001" :value="text"-->
                  <!--                              @change="getUsageAmount(record, $event)" :disabled="disableSubmit" />-->
                  <!--                            <j-dict-select-tag :triggerChange="true" :defaultState="true"-->
                  <!--                              dictCode="asset_om_quantity_unit" :search="true" :value="dataItem[index1].usageAmountUnit"-->
                  <!--                              placeholder="请选择单位" :disabled="true" @change="getUsageAmountUnit(index1, $event)"-->
                  <!--                              style="margin-left: 10%; width: 40%">-->
                  <!--                            </j-dict-select-tag>-->
                  <!--                          </template>-->

                  <!--                          <template v-if="record.code == 'verificationValue'">-->
                  <!--                            <a-input-number style="width: 50%" :step="0.001" :value="text"-->
                  <!--                              @change="getVerificationValue(record, $event)" :disabled="disableSubmit" />-->
                  <!--                            <j-dict-select-tag :triggerChange="true" :defaultState="true" dictCode="ref_unit"-->
                  <!--                              :search="true" :value="dataItem[index1].verificationUnit" placeholder="请选择单位"-->
                  <!--                              :disabled="disableSubmit" @change="getVerificationUnit(index1, $event)"-->
                  <!--                              style="margin-left: 10%; width: 40%">-->
                  <!--                            </j-dict-select-tag>-->
                  <!--                          </template>-->

                  <!--                          <template v-if="record.code == 'equipmentValue'">-->
                  <!--                            <a-input-number style="width: 50%" :step="0.001" :value="text"-->
                  <!--                              @change="getEquipmentValue(record, $event)" :disabled="disableSubmit" />-->
                  <!--                            <j-dict-select-tag :triggerChange="true" :defaultState="true" dictCode="ref_unit"-->
                  <!--                              :search="true" :value="dataItem[index1].equipmentUnit" placeholder="请选择单位"-->
                  <!--                              :disabled="disableSubmit" @change="getEquipmentUnit(index1, $event)"-->
                  <!--                              style="margin-left: 10%; width: 40%">-->
                  <!--                            </j-dict-select-tag>-->
                  <!--                          </template>-->

                  <!--                          <template v-if="record.code == 'absoluteError'">-->
                  <!--                            <a-input-number style="width: 50%" :step="0.001" :value="text"-->
                  <!--                              @change="getAbsoluteError(record, $event)" :disabled="disableSubmit" />-->
                  <!--                            <j-dict-select-tag :triggerChange="true" :defaultState="true" dictCode="ref_unit"-->
                  <!--                              :search="true" :value="dataItem[index1].absoluteUnit" placeholder="请选择单位"-->
                  <!--                              :disabled="disableSubmit" @change="getAbsoluteUnit(index1, $event)"-->
                  <!--                              style="margin-left: 10%; width: 40%">-->
                  <!--                            </j-dict-select-tag>-->
                  <!--                          </template>-->

                  <!--                          <template v-if="record.code == 'relativeError'">-->
                  <!--                            <a-input-number style="width: 100%" :step="0.001" :value="record.value"-->
                  <!--                              @change="getRelativeError(record, $event)" :disabled="disableSubmit" />-->
                  <!--                          </template>-->

                  <!--                          <template v-if="record.code == 'qualified'">-->
                  <!--                            <j-dict-select-tag :triggerChange="true" :defaultState="true" dictCode="yes_no_status"-->
                  <!--                              :value="record.value" @change="getQualified(record, $event)" placeholder="请选择是否达标"-->
                  <!--                              :disabled="disableSubmit" style="width: 100%">-->
                  <!--                            </j-dict-select-tag>-->
                  <!--                          </template>-->

                  <!--                          <template v-if="record.code == 'remark'">-->
                  <!--                            <a-textarea :autoSize="{ minRows: 5, maxRows: 5 }" placeholder="请输入备注..."-->
                  <!--                              v-model="record.value" :disabled="disableSubmit" />-->
                  <!--                          </template>-->
                  <!--                        </template>-->
                  <!--                        <template slot="action" slot-scope="text, record, index">-->
                  <!--                          <div style="max-width: 400px">-->
                  <!--                            <iws-upload v-if="record.hasOwnProperty('fileSrc')" :ref="'iwupload' + index"-->
                  <!--                              accept=".png,.jpg,.svg,.jpeg" :options="{ btnText: '上传' }" :disableSubmit="disableSubmit"-->
                  <!--                              :filesrc="record.fileSrc" :isLineBreak="true" :srcid="record.srcId"-->
                  <!--                              @change="changeUpload($event, record)"></iws-upload>-->
                  <!--                          </div>-->
                  <!--                        </template>-->
                  <!--                      </a-table>-->
                  <!--                    </div>-->
                  <!--                    <div v-if="dataItem.length == 0 && !disableSubmit"-->
                  <!--                      style="text-align: center; margin-top: 20vh; font-size: 20px">-->
                  <!--                      暂无数据,<span style="color: red; cursor: pointer" @click="addTable">去添加</span>-->
                  <!--                    </div>-->
                  <!--                    <div v-if="disableSubmit && dataItem.length == 0"-->
                  <!--                      style="color: #fff; font-size: 40px; text-align: center; margin-top: 30vh">-->
                  <!--                      暂无数据-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <a-pagination style="width: 100%; display: flex; justify-content: center; margin: 10px" :pageSize="1"-->
                  <!--                    v-model="tablePageIndex" :total="dataItem.length" />-->
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-spin>
        <div class="drawer-tool" v-show="!disableSubmit">
          <a-button icon="close" @click="handleCancel">取消</a-button>
          <a-button type="primary" :disabled="!networkStatus" icon="check" @click="handleOk">确定</a-button>
        </div>
      </a-tab-pane>
    </a-tabs>
    <select-asset-chemical-modal ref="AssetChemicalModal"
      @selectProduct="choseAssetChemical"></select-asset-chemical-modal>
    <select-asset-modal ref="AssetListModal" @selectProduct="choseProduct"></select-asset-modal>
  </a-drawer>
</template>

<script>
import SelectAssetChemicalModal from '@views/assets/SelectAssetChemicalModal1'
import { ModalFormMixin } from '@/mixins/ModalFormMixin'
import pick from 'lodash.pick'
import { getAction, httpAction } from '@api/manage'
import { getTenantStByToken, queryUserTreeList, queryFactorList, } from '@/api/api'
import moment from 'moment'
import IwsUpload from '@comp/upload/IwsUpload'
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin'
import SelectAssetModal from '@views/assets/SelectAssetModal'
import { isNullOrEmpty } from '@/utils/util'

const columnsItem = [
  {
    title: '仪表名称',
    dataIndex: 'equipmentId',
    align: 'center',
    width: '18%',
    scopedSlots: { customRender: 'equipmentId' },
  },
  {
    title: '标物名称',
    dataIndex: 'productId',
    align: 'center',
    width: '18%',
    scopedSlots: { customRender: 'productId' },
  },
  {
    title: '使用数量',
    dataIndex: 'usageAmount',
    align: 'center',
    width: '10%',
    scopedSlots: { customRender: 'usageAmount' },
  },
  {
    title: '核查值',
    dataIndex: 'verificationValue',
    width: '8%',
    align: 'center',
    scopedSlots: { customRender: 'verificationValue' },
  },
  {
    title: '仪器测定值',
    align: 'center',
    dataIndex: 'equipmentValue',
    width: '12%',
    scopedSlots: { customRender: 'equipmentValue' },
  },
  {
    title: '绝对误差',
    align: 'center',
    dataIndex: 'absoluteError',
    width: '8%',
    scopedSlots: { customRender: 'absoluteError' },
  },
  {
    title: '相对误差(%)',
    dataIndex: 'relativeError',
    align: 'center',
    width: '120px',
    scopedSlots: { customRender: 'relativeError' },
  },
  {
    title: '是否达标',
    dataIndex: 'qualified',
    align: 'center',
    width: '100px',
    scopedSlots: { customRender: 'qualified' },
  },
  {
    title: '备注',
    align: 'center',
    width: '10%',
    dataIndex: 'remark',
    scopedSlots: { customRender: 'remark' },
  },
  {
    title: '操作',
    align: 'center',
    width: '15%',
    dataIndex: 'operation',
    scopedSlots: {
      customRender: 'operation',
    },
  },
]

const dataItem = []
const addItemDataIndex = 0

export default {
  name: 'ReagentVerificationModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    IwsUpload,
    SelectAssetChemicalModal,
    SelectAssetModal,
  },
  data() {
    this.cacheItemData = dataItem.map((item) => ({ ...item }))
    return {
      title: '标液核查表单',
      tableName: 'om_reagent_verification',
      form_fields: ['siteId', 'userId', 'category', 'remark', 'tenantId'],
      form_fields_time: ['verificationDate', 'lastTime'],
      codeDict: 'equipmentId,productId',
      userTree: [],
      tablePageIndex: 1,
      tabsKey: '1',
      dataItem: [],
      tableData: [],
      equipmentOptions: [],
      tableData: [],
      columnsItem,
      columns: [],
      columns21: [
        {
          title: '核查因子',
          dataIndex: 'factorId',
          align: 'center',
          width: '20%',
          scopedSlots: { customRender: 'factorId' },
        },
        {
          title: '标准液浓度',
          dataIndex: 'concentration',
          align: 'center',
          width: '12%',
          scopedSlots: { customRender: 'concentration' },
        },
        {
          title: '仪器测定值',
          dataIndex: 'measuredValue',
          align: 'center',
          width: '12%',
          scopedSlots: { customRender: 'measuredValue' },
        },
        {
          title: '绝对误差',
          dataIndex: 'absoluteError',
          align: 'center',
          width: '12%',
          scopedSlots: { customRender: 'absoluteError' },
        },
        {
          title: '相对误差(%)',
          align: 'center',
          width: '12%',
          dataIndex: 'relativeError',
          scopedSlots: { customRender: 'relativeError' },
        },
        {
          title: '是否合格',
          dataIndex: 'qualified',
          align: 'center',
          width: '10%',
          scopedSlots: { customRender: 'qualified' },
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'remark',
          width: '25%',
          scopedSlots: { customRender: 'remark' },
        },
      ],
      columns31: [
        {
          title: '核查因子',
          dataIndex: 'factorId',
          align: 'center',
          width: '18%',
          scopedSlots: { customRender: 'factorId' },
        },
        {
          title: '标气浓度',
          dataIndex: 'concentration',
          align: 'center',
          width: '10%',
          scopedSlots: { customRender: 'concentration' },
        },
        {
          title: '上次校准后值',
          dataIndex: 'afterTheLastCalibration',
          align: 'center',
          width: '10%',
          scopedSlots: { customRender: 'afterTheLastCalibration' },
        },
        {
          title: '本次校准前之前测量值（仪器测定浓度）',
          dataIndex: 'beforeThisCalibration',
          align: 'center',
          width: '10%',
          scopedSlots: { customRender: 'beforeThisCalibration' },
        },
        {
          title: '仪器量程',
          dataIndex: 'instrumentRange',
          align: 'center',
          width: '10%',
          scopedSlots: { customRender: 'instrumentRange' },
        },
        {
          title: '相对误差(％)',
          align: 'center',
          dataIndex: 'relativeError',
          width: '10%',
          scopedSlots: { customRender: 'relativeError' },
        },
        {
          title: '是否合格',
          dataIndex: 'qualified',
          align: 'center',
          width: '10%',
          scopedSlots: { customRender: 'qualified' },
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'remark',
          width: '20%',
          scopedSlots: { customRender: 'remark' },
        },
      ],
      addItemDataIndex,
      validatorRules: {
        userId: { rules: [{ required: true, message: '请输入运维人员!' }] },
        verificationDate: { rules: [{ required: true, message: '请输入本次核查时间!' }] },
        category: { rules: [{ required: true, message: '请选择核查类型!' }] },
        fileList: { rules: [{ required: true, message: '请上传核查文件!' }] },
        lastTime: { rules: [{ required: true, message: '请输入上次核查时间!' }] },
      },
      url: {
        querySiteDevice: '/om/chemical/replace/querySiteDevice/',
        queryProductAssets: '/om/chemical/replace/queryProductAssets/',
        queryChemicalReplaceItem: '/om/chemical/replace/item/',
        deleteChemicalReplaceItem: '/om/reagent/verification/item/',
      },
      selectedAssetChemical: [],
      row: 0,
      row1: 0,
      current: 0,
      tabsKey1: '1',
      siteId: '',
      siteName: '',
      deviceId: '',
      stList: [],
      st: '',
      siteTypeName: '',
      factorOptions: [],
      uploadFileList:[]
    }
  },
  props: ['pagePath'],
  watch: {
    currentSiteId(value) {
      this.siteId = value
    },
    currentSiteName(newVal) {
      this.siteName = newVal
    },
    currentSiteType(newVal) {
      this.st = newVal
      if (this.stList.length > 0) {
        this.siteTypeName = this.stList.filter(item => item.value === this.st)[0].title
      }
    },
    visible(newVal) {
      if (!newVal) {
        this.dataItem = []
      }
    },
  },
  created() {
    this.getTenantStList()
    this.getFactorList()
  },
  methods: {
    handleUploadFileList(uploadFileList){
				console.log('uploadFileList',uploadFileList)
				this.uploadFileList = uploadFileList
			},
    // 公共处理单位显示的数据
			handleLabelTxt(item){
				let unitStr = ``
				if(item['factorId']){
					let selectedItemIndex = this.factorOptions.findIndex(item1=>item1.id==item['factorId'])
					if(selectedItemIndex>-1){
						unitStr = `(${this.factorOptions[selectedItemIndex]['unitName']})`
					}
				}
				return unitStr
			},
    changeFactor(changeFactor){
      console.log('changeFactor')
      this.handleAbsoluteError(changeFactor)
    },
    // 计算绝对误差方法
    handleAbsoluteError(item) {
      this.$nextTick(() => {
        let toFixedNum = 1  //保留的小数位 默认1
        if(item['factorId']){
						let selectedItemIndex = this.factorOptions.findIndex(item1=>item1.id==item['factorId'])
						console.log('test',selectedItemIndex,this.itemList)
						if(selectedItemIndex>-1){
							toFixedNum = this.factorOptions[selectedItemIndex]['decimals']
						}
						
					}
        if (!isNullOrEmpty(item.concentration) && !isNullOrEmpty(item.measuredValue)) {
          let absErr = (item.measuredValue - 0) - (item.concentration - 0);
          item['absoluteError'] = parseFloat(absErr.toFixed(4)).toFixed(toFixedNum);
          this.handleRelativeError(item)
        } else {
          item['absoluteError'] = ''
        }
      })

    },
    // 计算相对误差方法
    handleRelativeError(item) {
      this.$nextTick(() => {
        let categoryStr = this.form.getFieldValue('category')
        let modelCategory = this.st == '31' ? 2 : 1
        let toFixedNum = 1  //保留的小数位
        item['relativeError'] = ''
        if (modelCategory == 1) {
          if (item.concentration && item['absoluteError']) {
            let relErr = (item['absoluteError']/item.concentration)*100;
							item['relativeError'] = parseFloat(relErr.toFixed(4)).toFixed(toFixedNum);
          }
        } else {
          console.log('modelCategory', modelCategory,categoryStr)
          // 零点漂移 量程漂移
          if (categoryStr == '7' || categoryStr == '8') {
            if (item.instrumentRange) {
              let relErr = ((item.beforeThisCalibration-item.afterTheLastCalibration)/item.instrumentRange)*100;
								item['relativeError'] = parseFloat(relErr.toFixed(4)).toFixed(toFixedNum);
            }
          } else if (categoryStr == '9') {
            // 标气核查
            if (item.concentration) {
              let relErr = ((item.beforeThisCalibration-item.concentration)/item.concentration)*100;
								item['relativeError'] = parseFloat(relErr.toFixed(4)).toFixed(toFixedNum);
            }

          }
        }
      })
    },
    getFactorList() {
      // 获取所有监测因子
      let params = {
        pageNo: 1,
        pageSize: 10000,
        status: 1
      }
      queryFactorList(params).then((res) => {
        if (res.success) {
          this.factorOptions = res.result.records
        }
      })
    },
    getTenantStList() {
      getTenantStByToken().then((res) => {
        if (res.success) {
          this.stList = res.result
          this.siteTypeName = this.stList.filter(item => item.value === this.st)[0].title
        }
      })
    },
    moment,
    getQualified(value, e) {
      value['qualified'] = e
    },
    getAbsoluteError(value, e) {
      value['value'] = e
    },
    getEquipmentValue(value, e) {
      if (e != '') {
        if (e < 0) {
          this.$message.warning('产品数量不能为负数')
        } else {
          value['value'] = e
        }
      }
    },
    getVerificationValue(value, e) {
      if (e != '') {
        if (e < 0) {
          this.$message.warning('产品数量不能为负数')
        } else {
          value['value'] = e
        }
      }
    },
    getUsageAmount(value, e) {
      if (e != '') {
        if (e < 0) {
          this.$message.warning('产品数量不能为负数')
        } else {
          value['value'] = e
        }
      }
    },
    // // 单位选择框方法
    // getUsageAmountUnit(index, e) {
    //   this.dataItem[index].usageAmountUnit = e
    // },
    // getVerificationUnit(index, e) {
    //   this.dataItem[index].verificationUnit = e
    // },
    // getEquipmentUnit(index, e) {
    //   this.dataItem[index].equipmentUnit = e
    // },
    // getAbsoluteUnit(index, e) {
    //   this.dataItem[index].absoluteUnit = e
    // },
    selectAssetChemical(record, index, index1) {
      this.row = index
      this.current = index1
      this.selectedRecord = record
      this.$refs.AssetChemicalModal.category = 23
      this.$refs.AssetChemicalModal.disableSubmit = true
      this.$refs.AssetChemicalModal.add(this.selectedAssetChemical, this.assetChemicalIds, this.deviceId)
    },
    // 子modal回调
    choseAssetChemical: function (productList) {
      console.log('productList', productList[0])
      let item = this.dataItem[this.current]
      item[this.row].productId = productList[0].id
      item[this.row].value = productList[0].name + '(' + productList[0].unit_dictText + ')'
      this.$forceUpdate()
      console.log(this.dataItem)
    },
    // 仪器名称
    // selectAssets(record, index, index1) {
    //   this.row1 = index
    //   this.tableKey1 = index1
    //   this.selectedRecord = record
    //   this.$refs.AssetListModal.siteId = this.siteId
    //   this.$refs.AssetListModal.disableSubmit = true
    //   this.$refs.AssetListModal.add(record.productName, record.equipmentId)
    // },
    choseProduct: function (productList) {
      this.deviceId = ''
      this.dataItem.forEach((e, index) => {
        if (index === this.tableKey1) {
          e[this.row1].equipmentId = productList[0].id
          e[this.row1].value = productList[0].productName
          this.deviceId = productList[0].productId
        }
      })
      console.log('this.dataItem', this.dataItem)
      this.$forceUpdate()
    },
    add(siteId) {
      console.log('record', siteId)
      if (undefined == siteId) this.$message.warning('请选择单个站点')
      this.edit({ siteId })
    },
    edit(record) {
      if (this.st === '21' || this.st === '32') {
        this.columns = JSON.parse(JSON.stringify(this.columns21))
      } else if (this.st === '31') {
        this.columns = JSON.parse(JSON.stringify(this.columns31))
      }
      if (!this.disableSubmit) {
        this.columns.push({
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          width: '20%',
          scopedSlots: { customRender: 'action' },
        })
      }
      this.tabsKey = '1'
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.model.st = this.st
      this.loadTreeList(this.model.siteId)
      this.visible = true
      // this.visible1 = false
      this.selectedRowKeys = []
      this.selectionRows = []
      if (undefined == this.model.id) {
        this.dataItem = []
        this.model.userId = this.$store.getters.userInfo.id
        this.model.verificationDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
      } else {
        this.getTableItem()
      }
      this.$nextTick(() => {
        var that = this
        that.form.setFieldsValue(pick(that.model, that.form_fields))
        //时间格式化
        let timeVal = {}
        that.form_fields_time.forEach((item, index) => {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null
        })
        that.form.setFieldsValue(timeVal)
        this.$refs.iwupload.loadUploadFiles()
      })
    },
    getTableItem() {
      getAction(`/reagent/verification/st${this.st}/item/getItem/${this.model.id}`).then((res) => {
        if (res.success) {
          this.dataItem = res.result
        }
        // let arr = []
        // verificationItem = res.result.records
        // verificationItem.forEach((item) => {
        //
        // })
        // this.dataItem = arr
      })
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let formData = Object.assign(that.model, values)
          formData.lastTime = formData.lastTime
            ? formData.lastTime.format('YYYY-MM-DD HH:mm:ss')
            : null
          //时间格式化
          formData.verificationDate = formData.verificationDate
            ? formData.verificationDate.format('YYYY-MM-DD HH:mm:ss')
            : null
          if (that.st === '21'||that.st === '32') {
            formData.st21ItemList = that.dataItem
          } else if (that.st === '31') {
            formData.st31ItemList = that.dataItem
          }
          // formData = this.$refs.iwupload.getUploadListToFromData(formData)
          // that.dataItem.forEach((item, index) => {
          //   let obj = {}
          //   let sysFileList = []
          //   let fileDelList = []
          //   item.forEach((item1, index) => {
          //     obj[item1.code] = item1.value
          //     if (item1.hasOwnProperty('productId')) {
          //       obj.productId = item1.productId
          //     }
          //     if (item1.hasOwnProperty('equipmentId')) {
          //       obj.equipmentId = item1.equipmentId
          //     }
          //     if (item1.sysFileList) {
          //       sysFileList = sysFileList.concat(item1.sysFileList)
          //       fileDelList = fileDelList.concat(item1.fileDelList)
          //     }
          //   })
          //   obj['usageAmountUnit'] = item.usageAmountUnit
          //   obj['verificationUnit'] = item.verificationUnit
          //   obj['equipmentUnit'] = item.equipmentUnit
          //   obj['absoluteUnit'] = item.absoluteUnit
          //   obj.sysFileList = sysFileList
          //   obj.fileDelList = fileDelList
          //   obj['id'] = item.id
          //   tableData.push(obj)
          // })

          let httpurl = '',
            method = ''
          if (!this.model.id) {
            httpurl = this.url.add ? this.url.add : this.pagePath
            method = 'post'
          } else {
            httpurl = this.url.edit ? this.url.edit : this.pagePath
            method = 'put'
          }
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                this.$refs.iwupload.resetUploadFiles()
                that.$notification.success({ message: res.message })
                that.$emit('ok')
                that.close()
              } else {
                that.$notification.warning({ message: res.message })
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        } else {
          this.tabsKey = '1'
        }
      })
    },
    loadTreeList(params) {
      var that = this
      that.userTree = []
      that.equipmentOptions = []
      // 用户
      queryUserTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.userTree.push(temp)
          }
        }
      })

      // 站点设备
      getAction(this.url.querySiteDevice + params).then((res) => {
        if (res.success) {
          that.equipmentOptions = res.result
        }
      })
    },

    addTable() {
      if (this.st === '21') {
        this.dataItem.push({
          factorId: '',
          concentration: '',
          measuredValue: '',
          absoluteError: '',
          relativeError: '',
          qualified: '',
          remark: '',
        })
      } else if (this.st === '31') {
        this.dataItem.push({
          factorId: '',
          concentration: '',
          afterTheLastCalibration: '',
          beforeThisCalibration: '',
          instrumentRange: '',
          relativeError: '',
          qualified: '',
          remark: '',
        })
      } else if (this.st === '32') {
        this.dataItem.push({
          factorId: '',
          concentration: '',
          measuredValue: '',
          absoluteError: '',
          relativeError: '',
          qualified: '',
          remark: '',
        })
      }
      // const newData = [...this.tableData]
      // newData.push({
      //   equipmentId: '',
      //   productId: '',
      //   usageAmount: '',
      //   equipmentValue: '',
      //   absoluteError: '',
      //   relativeError: '',
      //   remark: '',
      //   editable: true,
      // })
      // this.tableData = newData
      //
      // let dataObj = {
      //   equipmentId: '',
      //   productId: '',
      //   usageAmount: '',
      //   equipmentValue: '',
      //   absoluteError: '',
      //   relativeError: '',
      //   remark: '',
      //   editable: true,
      // }
      // let arr = []
      // this.columnsItem.forEach((item, index) => {
      //   if (index < this.columnsItem.length - 1) {
      //     let tableData = {
      //       title: item.title,
      //       code: item.dataIndex,
      //       value: null,
      //     }
      //     if (this.codeDict.indexOf(tableData.code) > -1) {
      //       tableData.fileSrc = `om_reagent_verification_item_${tableData.code}`
      //       tableData.srcId = null
      //     }
      //     arr.push(tableData)
      //   }
      // })
      // this.dataItem.push(arr)
      // this.tablePageIndex = this.dataItem.length
    },
    handleChangeTable(record, index, index2) {
      let item = this.dataItem[index2]
      item.forEach((item1, index1) => {
        if (index1 > index && index1 < item.length - 4) {
          item1.value = ''
        }
      })
      this.$set(this.dataItem, index2, item)
      this.$forceUpdate()
    },
    handleChangeRestriction(value, key, column) {
      const newData = [...this.dataItem]
      const target = newData.filter((item) => key === item.key)[0]
      // const target1 = newData.filter(item => key != item.key)[0]
      if (target) {
        target[column] = value
        this.dataItem = newData
      }
    },
    delTable(key) {
      const newData = this.dataItem.filter((item) => key != item.key)
      this.dataItem = newData
      this.cacheItemData = newData.map((item) => ({ ...item }))
    },
    editTable(key) {
      const newData = [...this.dataItem]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        target.editable = true
        this.dataItem = newData
      }
    },
    saveTable(key) {
      const newData = [...this.dataItem]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        delete target.editable
        this.dataItem = newData
        this.cacheItemData = newData.map((item) => ({ ...item }))
      }
    },
    cancelTable(key) {
      const newData = [...this.dataItem]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        Object.assign(target, this.cacheItemData.filter((item) => key === item.key)[0])
        delete target.editable
        this.dataItem = newData
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    changeUpload(e, record) {
      e.sysFileList.forEach((item) => {
        item.fileSrc = record.fileSrc
      })
      e.fileDelList.forEach((item) => {
        item.fileSrc = record.fileSrc
      })
      console.log('e,record', e, record)

      record.sysFileList = e.sysFileList
      record.fileDelList = e.fileDelList

      console.log('this', this.tableData)
    },
    handleDelete(index) {
      this.dataItem.splice(index, 1)
      // if (this.dataItem.length <= 0) return
      // if (id) {
      //   this.dataItem.splice(this.tablePageIndex - 1, 1)
      //   httpAction(this.url.deleteChemicalReplaceItem + '?id=' + id, '', 'DELETE').then((res) => {
      //     if (res.success) {
      //       this.$notification.success({
      //         message: res.message,
      //       })
      //     } else {
      //       this.$notification.warning({
      //         message: res.message,
      //       })
      //     }
      //   })
      // } else {
      //   this.dataItem.splice(this.tablePageIndex - 1, 1)
      // }
      // if (this.dataItem.length > 1 && this.tablePageIndex > 1) {
      //   this.tablePageIndex--
      // } else {
      //   this.tablePageIndex = 1
      // }
    },

  },
}
</script>

@import '~@assets/less/common.less';@import '~@assets/less/common.less';
</style>